<app-dashboard-layout [loading]="loading">
  <section class="bg-white border rounded-md p-6">
    <header class="border-b text-lg w-full pb-2 md:text-xl">
      Accommodation Instructions
    </header>

    <section *ngIf="loading">
      <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
      <div class="border rounded-md bg-gray-300 h-10 my-4 animate-pulse"></div>
      <div class="border rounded-md bg-gray-300 h-10 my-4 animate-pulse"></div>
    </section>

    <div *ngIf="!loading" class="pt-4 space-y-6">
      <p class="text-sm text-gray-600 font-medium">
        Please read the terms and conditions as well as the instructions below before proceeding.
      </p>

      <div
        [innerHtml]="ProgrammeTypeAccomodationInstructions"
        class="text-sm text-gray-600 prose max-w-none border rounded-md p-4 bg-gray-50"
      ></div>

      <div class="flex items-start gap-3 p-4 bg-gray-50 border rounded-md">
        <input
          type="checkbox"
          id="acknowledge"
          (change)="toggleAcknowledgment($event)"
          class="mt-0.5 w-4 h-4 cursor-pointer accent-primary"
        />
        <label for="acknowledge" class="text-sm text-gray-700 cursor-pointer">
          I have read and understood the accommodation instructions and terms stated above.
        </label>
      </div>

      <div class="flex gap-3">
        <app-button-primary [outline]="true" (click)="back()" class="w-full">
          Back
        </app-button-primary>
        <app-button-primary
          (click)="acknowledgeInstructions()"
          [disabled]="!acknowledged"
          class="w-full"
        >
          Continue
        </app-button-primary>
      </div>
    </div>
  </section>
</app-dashboard-layout>
